import {Box, Button, Paper, Stack, Typography} from "@mui/material";
import {AccessTimeOutlined, AllInclusiveOutlined, ArticleOutlined, InsertDriveFileOutlined} from "@mui/icons-material";
import {green} from "@mui/material/colors";
import {convertSize} from "../../../lib/commonFunctions/convertSize";

const Info = ({data, files}) => {



    const fileTypes = files?.length ? [...new Set(files.map(f => f.type.toUpperCase()))].join(' ,') : '';
    const filesSize = files?.length ? convertSize(files.map(f => f.size).reduce((partialSum, a) => partialSum + a, 0), {farsi: true}) : 'نامشخص';
    // const filesPrize = files?.length;

    return (
        <Paper sx={{ p: {xs: 2, lg: 2.5} }}>
            <Stack spacing={2}>
                <Stack spacing={.5}>
                    <Box display="flex" alignItems="center">
                        <ArticleOutlined color="primary"/>
                        <Typography ml={.75} fontSize={{ xs: ".9rem" }} fontWeight={500}>توضیحات:</Typography>
                    </Box>
                    <Typography fontSize={{ xs: ".825rem" }}>{data.description ? data.description : "بدون توضیح"}</Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={.5}>
                    <Box display="flex" alignItems="center">
                        <InsertDriveFileOutlined color="primary"/>
                        <Typography ml={.75} fontSize={{ xs: ".9rem" }} fontWeight={500}>نوع فایل(ها):</Typography>
                    </Box>
                    <Typography fontSize={{ xs: ".825rem" }}>{fileTypes ? fileTypes : "نامشخص"}</Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={.5}>
                    <Box display="flex" alignItems="center">
                        <AllInclusiveOutlined color="primary"/>
                        <Typography ml={.75} fontSize={{ xs: ".9rem" }} fontWeight={500}>حجم کل:</Typography>
                    </Box>
                    <Typography fontSize={{ xs: ".825rem" }}>{filesSize}</Typography>
                </Stack>
                {/*<Stack direction="row" alignItems="center" spacing={.5}>*/}
                {/*    <Box display="flex" alignItems="center">*/}
                {/*        <AccessTimeOutlined color="primary"/>*/}
                {/*        <Typography ml={.75} fontSize={{ xs: ".9rem" }} fontWeight={500}>زمان اعتبار:</Typography>*/}
                {/*    </Box>*/}
                {/*    <Typography fontSize={{ xs: ".825rem" }}>۳۰ روز دیگر</Typography>*/}
                {/*</Stack>*/}
                {/*<Stack direction="row" alignItems="center" spacing={.5}>*/}
                {/*    <Box display="flex" alignItems="center">*/}
                {/*        <AccessTimeOutlined color="primary"/>*/}
                {/*        <Typography ml={.75} fontSize={{ xs: ".9rem" }} fontWeight={500}>قیمت:</Typography>*/}
                {/*    </Box>*/}
                {/*    <Typography fontSize={{ xs: ".825rem" }}>۲۵۰,۰۰۰ تومان</Typography>*/}
                {/*</Stack>*/}
            </Stack>
            {/*<Button fullWidth variant="contained" color="success" sx={{ mt: 3, py: 1.5, backgroundColor: green[600] }} disableElevation>خرید</Button>*/}
        </Paper>
    )
}
export default Info;